import { Fragment, useState } from 'react'
import { Dialog, Disclosure, Popover, Transition } from '@headlessui/react'
import { ChevronDownIcon, PhoneIcon } from '@heroicons/react/20/solid'
import '../../styles/components/nav.css';
import '../../styles/components/header.css';
import {
    GlobeEuropeAfricaIcon, CloudArrowUpIcon, CodeBracketIcon,
    Bars3Icon,
    XMarkIcon,
} from '@heroicons/react/24/outline'
import ProgressBar from '../ui/process_bar';
import logo from '../../logo192.png'

const products = [
    { name: 'CUSTOM SOFTWARE DEVELOPMENT', description: 'When off-the-shelf software wont cut it', href: '/services/Custom_software_development', icon: CodeBracketIcon },
    { name: 'WEB APP DEVELOPMENT', description: 'Customize business solutions to digital products', href: '/services/Web_app_development', icon: GlobeEuropeAfricaIcon },
    { name: 'PRODUCT MANAGEMENT SERVICES    ', description: 'Your customers’ data will be safe and secure', href: '/services/product_management', icon: CloudArrowUpIcon },
]
const callsToAction = [

    { name: 'Contact for inquiry', href: 'tel:+94773112006', icon: PhoneIcon },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Navbar() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    return (
        <header className="fixed-header">
            <nav className="mx-auto flex w-full items-center justify-start p-2 lg:px-8 shadow-sm" aria-label="Global">
                <div className="flex items-center">
                    <a href="https://algoarts.tech/" className="-m-1.5 p-1.5 flex items-center">
                        <img className="h-14 w-auto" src={logo} alt="Algoarts Logo" />
                        <div className="ml-1">
                            <span className="text-2xl font-bold font-poppins text-gray-800">Algoarts</span>
                            <span className="block text-sm font-bold font-poppins text-gray-600 hidden sm:block">Turning Ideas into Digital Reality.</span>
                        </div>
                    </a>

                </div>
                {/* ham burger icon */}
                <div className="flex lg:hidden absolute top-2 right-2 mt-4 mr-6">
                    <button
                        type="button"
                        className="-m-2 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400  opacity-60"
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon className="h-10 w-10" aria-hidden="true" />
                    </button>
                </div>
                {/* ham burger icon */}
                {/* servicebutton */}
                <Popover.Group className="hidden lg:flex lg:gap-x-10 ml-16">
                    <Popover className="relative">
                        <div className="group relative">
                            <Popover.Button className="flex items-center gap-x-1 text-lg text-lg text-dark font-semibold font-lexend leading-6 text-gray-600">
                                Services
                                <span className="absolute bottom-[-23px] left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-purple-400 to-pink-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                                <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                            </Popover.Button>
                        </div>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                        >
                            <div className="absolute left-0 top-full z-10 mt-8 w-screen max-w-md overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5 max-h-[calc(100vh-5rem)] overflow-y-auto">
                                <div className="p-4">
                                    {products.map((item) => (
                                        <div
                                            key={item.name}
                                            className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:text-white"
                                        >
                                            <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                                <item.icon className="h-6 w-6 text-gray-600 group-hover:text-indigo-600" aria-hidden="true" />
                                            </div>
                                            <div className="flex-auto">
                                                <a href={item.href} className="block font-semibold font-lexend">
                                                    {item.name}
                                                    <span className="absolute inset-0" />
                                                </a>
                                                <p className="mt-1 hover:text-white">{item.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="divide-x divide-gray-900/5 bg-gray-50">
                                    {callsToAction.map((item) => (
                                        <a
                                            key={item.name}
                                            href={item.href}
                                            className="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:text-white"
                                        >
                                            <item.icon className="h-5 w-5 flex-none text-gray-400 hover:text-white" aria-hidden="true" />
                                            {item.name}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </Transition>
                    </Popover>
                    {/* servicebutton */}
                    {/* navitemlist */}
                    <div className="group relative">
                        <a href="/academy/blog" className="text-lg text-dark font-semibold font-lexend leading-6 text-gray-600">
                            Blog
                            <span className="absolute bottom-[-23px] left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-purple-400 to-pink-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                        </a>
                    </div>
                    <div className="group relative">
                        <a href="/careers" className="text-lg text-dark font-semibold font-lexend leading-6 text-gray-600">
                            Careers
                            <span className="absolute bottom-[-23px] left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-purple-400 to-pink-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                        </a>
                    </div>
                    <div className="group relative">
                        <a href="/our_works" className="text-lg text-dark font-semibold font-lexend leading-6 text-gray-600">
                            Our Work
                            <span className="absolute bottom-[-23px] left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-purple-400 to-pink-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                        </a>
                    </div>
                    <div className="group relative">
                        <a href="/about_us" className="text-lg text-dark font-semibold font-lexend leading-6 text-gray-600">
                            About Us
                            <span className="absolute bottom-[-23px] left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-purple-400 to-pink-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                        </a>
                    </div>
                    {/* navitemlist */}

                    <ProgressBar />
                </Popover.Group>
                {/* call button */}

                <div className="ml-auto flex items-center">
                    <div className="group relative hidden md:block">
                        <a href="tel:+94705035126" className="text-lg text-dark font-semibold font-lexend leading-6 text-gray-600">
                            Make a Call
                            <span className="absolute bottom-[-23px] left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-purple-400 to-pink-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-in-out"></span>
                        </a>
                    </div>

                </div>
                {/* call button */}
            </nav>
            <Transition show={mobileMenuOpen} as={Fragment}>
                <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={() => setMobileMenuOpen(false)} />
                    </Transition.Child>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="translate-x-full"
                        enterTo="translate-x-0"
                        leave="ease-in duration-200"
                        leaveFrom="translate-x-0"
                        leaveTo="translate-x-full"
                    >
                        <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full max-w-sm overflow-y-auto bg-[#0F072C] shadow-xl">
                        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700">
                            <div className="flex items-center gap-3">
                                <img
                                    className="h-8 w-auto"
                                    src="https://contctcss.vercel.app/algoarts_logo.png"
                                    alt="Algoarts Logo"
                                />
                                <span className="text-white font-bold font-poppins text-lg">Algoarts</span>
                            </div>
                            <button
                                type="button"
                                className="rounded-md p-2 text-white hover:bg-gray-800 transition-colors"
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                        </div>
                        <div className="px-6 py-6">
                            <div className="space-y-1">
                                <Disclosure as="div">
                                    {({ open }) => (
                                        <>
                                            <Disclosure.Button className="text-white flex w-full items-center justify-between rounded-lg py-3 px-4 text-base font-semibold font-lexend leading-7 hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all">
                                                Services
                                                <ChevronDownIcon
                                                    className={classNames(open ? 'rotate-180' : '', 'h-5 w-5 flex-none transition-transform')}
                                                    aria-hidden="true"
                                                />
                                            </Disclosure.Button>
                                            <Disclosure.Panel className="mt-2 space-y-1">
                                                {products.map((item) => (
                                                    <a
                                                        key={item.name}
                                                        href={item.href}
                                                        className="block rounded-lg py-2.5 pl-8 pr-4 text-sm font-semibold leading-7 text-gray-300 hover:bg-gradient-to-r hover:from-indigo-500 hover:via-purple-500 hover:to-pink-500 hover:text-white transition-all"
                                                        onClick={() => setMobileMenuOpen(false)}
                                                    >
                                                        {item.name}
                                                    </a>
                                                ))}
                                                {callsToAction.map((item) => (
                                                    <a
                                                        key={item.name}
                                                        href={item.href}
                                                        className="block rounded-lg py-2.5 pl-8 pr-4 text-sm font-semibold leading-7 text-gray-300 hover:bg-gradient-to-r hover:from-indigo-500 hover:via-purple-500 hover:to-pink-500 hover:text-white transition-all"
                                                        onClick={() => setMobileMenuOpen(false)}
                                                    >
                                                        {item.name}
                                                    </a>
                                                ))}
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                                <a
                                    href="/academy/blog"
                                    className="block rounded-lg py-3 px-4 text-base font-semibold font-lexend leading-7 text-white hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    Blog
                                </a>
                                <a
                                    href="/careers"
                                    className="block rounded-lg py-3 px-4 text-base font-semibold font-lexend leading-7 text-white hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    Careers
                                </a>
                                <a
                                    href="/our_works"
                                    className="block rounded-lg py-3 px-4 text-base font-semibold font-lexend leading-7 text-white hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    Our Work
                                </a>
                                <a
                                    href="/about_us"
                                    className="block rounded-lg py-3 px-4 text-base font-semibold font-lexend leading-7 text-white hover:bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 transition-all"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    About Us
                                </a>
                                <a
                                    href="tel:+94705035126"
                                    className="block rounded-lg py-3 px-4 text-base font-semibold font-lexend leading-7 text-white bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 mt-4 text-center"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    Make a Call
                                </a>
                            </div>
                        </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </Dialog>
            </Transition>
        </header>
    )
}
// dfgdfgdfgd